"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Renationalisation = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Resources_1 = require("../../../Resources");
const CardType_1 = require("../../../cards/CardType");
class Renationalisation {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.RENATIONALISATION;
        this.description = 'Lose 4 M€ for every set of 3 automated cards in play (max 5 sets), then reduced by influence.';
        this.revealedDelegate = PartyName_1.PartyName.CENTRISTS;
        this.currentDelegate = PartyName_1.PartyName.POPULISTS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const setsCount = Math.floor(player.playedCards.filter((card) => card.cardType === CardType_1.CardType.AUTOMATED).length / 3);
            const amount = Math.max(Math.min(setsCount, 5) - turmoil.getPlayerInfluence(player), 0);
            player.addResource(Resources_1.Resources.MEGACREDITS, amount * -4, { log: true });
        });
    }
}
exports.Renationalisation = Renationalisation;
//# sourceMappingURL=Renationalisation.js.map